<template>
    <div class="row">
        <div class="col-md-12" v-if="readonly.finalizado == 0">
            <form ref="form" :model="one" :readonly="readonly">
                <textarea class="form-control form-control-alternative" rows="3" placeholder="Agregar una nota..." v-model="oneTexto"></textarea>
                <div class="text-right">
                    <base-button type="success" class="my-2" @click="save"><i class="fa fa-plus"></i> Agregar</base-button>
                </div>
            </form>
        </div>
        <hr class="my-4" />
        <div class="col-md-12 mt-2">
            <div class="card shadow mb-4" v-for="item in all" :key="item.id" :class="item.idcontacto == contacto.id ? 'notaPrincipal' : 'notaSegundaria'">
                <div class="content-notas">
                    <div class="avatar-notas">
                        <div class="avatar-n">
                            <p>{{ getAcronym(item) }}</p>
                        </div>
                    </div>
                    <div class="content-text-notas">
                        <h5 :class="item.idcontacto == contacto.id ? 'text-primary' : 'text-success'">{{ item.idcontacto ? item.idcontactodesc : item.idusuariodesc }}</h5>
                        <div v-html="item.texto"></div>
                        <span>{{ item.fechahora }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .notaPrincipal {
        .content-notas {
            width: 100%;
            height: auto;
            padding: 5px;
            display: flex;

            .avatar-notas {
                width: 75px;
                height: auto;
                float: left;
                position: relative;

                .avatar-n {
                    width: 70px;
                    height: 70px;
                    background-color: #1da1f2;
                    border-radius: 50%;
                    display: table;
                    position: absolute;
                    left: -15px;
                    top: -15px;

                    p {
                        display: table-cell;
                        vertical-align: middle;
                        text-align: center;
                        font-size: 22px;
                        font-weight: 500;
                        color: #fff;
                    }
                }
            }

            .content-text-notas {
                width: 100%;
                height: auto;
                min-height: 120px;
                float: left;
                padding: 10px;

                p {
                    font-size: 12px;
                    line-height: 25px;
                }

                span {
                    font-size: 10px;
                    float: right;
                    color: #c3c3c3;
                    font-style: italic;
                }
            }
        }
    }

    .notaSegundaria {
        .content-notas {
            width: 100%;
            height: auto;
            padding: 5px;
            display: flex;

            .avatar-notas {
                width: 75px;
                height: auto;
                float: left;
                position: relative;

                .avatar-n {
                    width: 70px;
                    height: 70px;
                    background-color: #76eea7;
                    border-radius: 50%;
                    display: table;
                    position: absolute;
                    left: -15px;
                    top: -15px;

                    p {
                        display: table-cell;
                        vertical-align: middle;
                        text-align: center;
                        font-size: 22px;
                        font-weight: 500;
                        color: #fff;
                    }
                }
            }

            .content-text-notas {
                width: 100%;
                height: auto;
                min-height: 120px;
                float: left;
                padding: 10px;

                p {
                    font-size: 16px;
                    line-height: 25px;
                }

                span {
                    font-size: 10px;
                    float: right;
                    color: #c3c3c3;
                    font-style: italic;
                }
            }
        }
    }


    .vue-notification {
        margin-top: 15px;
    }
</style>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    export default {
        name: "Notas",
        props: {
            idobjeto: {
                default: null,
                required: true
            },
            tipoobjeto: {
                default: null,
                required: true
            },
            store: {
                type: String,
                default: 'notas'
            },
            readonly: {
                type: Object
            }
        },
        data() {
            return {
                oneTexto: ''
            }
        },
        computed: {
            all() {
                return this.$store.getters[`${this.store}/all`]
            },
            one() {
                return this.$store.getters[`${this.store}/one`]
            },
            query() {
                return { idobjeto: this.idobjeto, tipoobjeto: this.tipoobjeto }
            },
            ...mapGetters('auth', { contacto: 'contacto'}),
        },
        methods: {
            ...mapActions('notas', {getAllNotas: 'getAll'}),
            getAll(){
                Promise.all([
                    this.getAllNotas(this.query)
                ]).then(() => {
                })
            },
            getAcronym (item) {
                let owner = item.idcontacto ? 'idcontactodesc' : 'idusuariodesc'
                return (item[owner] || '').split(' ').map(word => (word[0] || '').toUpperCase()).join('')
            },
            save() {
                this.one.texto = this.oneTexto
                let data = {
                    ...this.query,
                    texto: this.one.texto
                }
                if (this.one.texto) {
                    this.$store.dispatch(`${this.store}/save`, data)
                    .then((data) => {
                        if (data.message !== null) {
                            this.$notify({
                                group: 'foo',
                                title: 'Mensaje',
                                type: 'error',
                                speed: 1000,
                                duration: 500,
                                text: data.message
                            });
                            this.readonly = true
                            this.oneTexto = ''
                        } else {
                            this.$notify({
                                group: 'foo',
                                title: 'Mensaje',
                                type: 'success',
                                speed: 1000,
                                duration: 500,
                                text: 'La nota se ha agregado exitosamente.'
                            });
                            this.oneTexto = ''
                            this.getAll()
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            title: 'Mensaje',
                            type: 'error',
                            speed: 1000,
                            duration: 500,
                            text: 'Ocurrió un error al intentar realizar la operación.'
                        });
                    })
                } else {
                    this.$notify({
                            group: 'foo',
                            title: 'Mensaje',
                            type: 'error',
                            speed: 1000,
                            duration: 500,
                            text: 'Se debe agregar un mensaje.'
                        });
                }
            }
        },
        mounted() {
            this.getAll()
        }
    }
</script>